
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.2 2.3a3.5 3.5 0 00-4.4 4.4l-3.4 3.4a1.4 1.4 0 000 2l1.5 1.5a1.4 1.4 0 002 0l3.4-3.4a3.5 3.5 0 004.4-4.4l-2.1 1.8-3.2-3.2 1.8-2.1z","stroke":"currentColor","stroke-width":"1.4","stroke-linejoin":"round"}})])
          )
        }
      }
    